import { createFileRoute } from '@tanstack/react-router';
import { SystemsListPage } from '@/features/systems/systems-list-page.js';

export const Route = createFileRoute('/_app/systems')({
  component: SystemsListPage,
});
